import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe that implements truncating of numbers and decimals
 */

@Pipe({
  name: 'rdsNumberTrunc'
})
export class RdsNumberTruncPipe extends DecimalPipe implements PipeTransform {
  transform(value: number): any {
    if (value === null || value === undefined) {
      return '';
    }
    if (value < 10) {
      return super.transform(value, '1.1-2');
    } else if (value < 100) {
      // Between 10 and 99
      return super.transform(value, '2.0-1');
    } else if (value < 1000) {
      // Between 100 and 999
      const trunc = Math.floor(value / 1);
      return super.transform(trunc, '3.0-0');
    } else if (value < 10000) {
      // Between 1,000 and 9,999
      const trunc = Math.floor(value / 100) / 10;
      return super.transform(trunc, '1.1-1') + 'k';
    } else if (value < 100000) {
      // Between 10,000 and 99,999
      const trunc = Math.floor(value / 1000);
      return super.transform(trunc, '2.0-1') + 'k';
    } else if (value < 1000000) {
      // Between 100,000 and 999,999
      const trunc = Math.floor(value / 1000);
      return super.transform(trunc, '3.0-0') + 'k';
    } else if (value < 10000000) {
      // Between 1,000,000 and 9,999,999
      const trunc = Math.floor(value / 100000) / 10;
      return super.transform(trunc, '1.1-1') + 'm';
    } else if (value < 100000000) {
      // Between 10,000,000 and 99,999,999
      const trunc = Math.floor(value / 1000000);
      return super.transform(trunc, '2.0-1') + 'm';
    } else if (value < 1000000000) {
      // Between 100,000,000 and 999,999,999
      const trunc = Math.floor(value / 10000000) / 10;
      return super.transform(trunc, '1.0-1') + 'b';
    } else if (value < 10000000000) {
      // Between 1,000,000,000 and 9,999,999,999
      const trunc = Math.floor(value / 100000000) / 10;
      return super.transform(trunc, '1.0-1') + 'b';
    } else if (value < 100000000000) {
      // Between 10,000,000,000 and 99,999,999,999
      const trunc = Math.floor(value / 1000000000);
      return super.transform(trunc, '2.0-1') + 'b';
    } else {
      console.error('RdsNumberTruncPipe - Number TOO YUGE to handle', value);
      return '...';
    }
  }
}
